import {
  Badge,
  Box,
  Dialog,
  DialogTitle,
  Divider,
  IconButton,
  Modal,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../constants/colors";
import { useState } from "react";
const CampusLogo = "https://lms-assets1.s3.ap-south-1.amazonaws.com/images/campus_logo.png";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    background: "linear-gradient(45deg, #f9ebeb, #FFFFFF, #e8f0f8);", // Set your desired background color here
    position: "absolute",
    top: 50,
    right: 0,
  },
  "& .MuiDialog-paper": {
    minWidth: "300px",
    maxWidth: "400px",
    maxHeight: "600px",
  },

  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const notifications = [
  {
    title: "Maintenance Alert",
    description:
      "Scheduled maintenance for elevator systems on Tower A starting tomorrow.",
    category: "Maintenance",
    date_and_time: "2023-12-01T09:00:00",
    image: "maintenance_alert_image.jpg",
    name: "Principal Smith",
  },
  {
    title: "New Product Launch",
    description:
      "Introducing our latest smart elevator model equipped with AI-driven safety features.",
    category: "Product Launch",
    date_and_time: "2023-12-05T10:30:00",
    image: "product_launch_image.jpg",
    name: "Admin Johnson",
  },
  {
    title: "Industry Conference",
    description:
      "Join us at the ElevateTech 2023 conference for discussions on future elevator technologies.",
    category: "Conference",
    date_and_time: "2023-12-10T14:00:00",
    image: "conference_image.jpg",
    name: "Teacher Williams",
  },
  {
    title: "Customer Showcase",
    description:
      "Celebrating 1000 successful elevator installations worldwide!",
    category: "Achievement",
    date_and_time: "2023-12-15T11:00:00",
    image: "customer_showcase_image.jpg",
    name: "Principal Miller",
  },
  {
    title: "Holiday Closure",
    description:
      "Our offices will remain closed on December 25th for the holiday season.",
    category: "Office Closure",
    date_and_time: "2023-12-25T00:00:00",
    image: "holiday_closure_image.jpg",
    name: "Admin Brown",
  },
  {
    title: "Training Session",
    description: "Employee training session on new elevator safety protocols.",
    category: "Training",
    date_and_time: "2024-01-05T13:45:00",
    image: "training_session_image.jpg",
    name: "Teacher Davis",
  },
  {
    title: "Customer Feedback Survey",
    description:
      "Share your experience with our elevator services in our latest survey.",
    category: "Customer Feedback",
    date_and_time: "2024-01-10T09:30:00",
    image: "feedback_survey_image.jpg",
    name: "Principal Martinez",
  },
  {
    title: "Project Update",
    description:
      "Progress update on the installation of elevators in the SkyView Towers project.",
    category: "Project Update",
    date_and_time: "2024-01-15T15:00:00",
    image: "project_update_image.jpg",
    name: "Admin Garcia",
  },
  {
    title: "Elevator Safety Awareness",
    description:
      "Promoting elevator safety awareness among building residents.",
    category: "Safety Awareness",
    date_and_time: "2024-01-20T11:00:00",
    image: "safety_awareness_image.jpg",
    name: "Teacher Rodriguez",
  },
  {
    title: "Tech Talk: Elevator Innovations",
    description:
      "Join us for a live tech talk on the future of elevator innovations.",
    category: "Tech Talk",
    date_and_time: "2024-01-25T16:30:00",
    image: "tech_talk_image.jpg",
    name: "Admin Wilson",
  },
];

export const NotificationModal = ({ open, setOpen }) => {
  const [value, setValue] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };

  const switchTab = (e, newValue) => {
    setValue(newValue);
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle sx={{ p: 3 }}>
        <div>
          <Typography
            variant="h5"
            color={colors.darkGreyFont}
            fontWeight={"bold"}
          >
            Notifications
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 20,
              top: 20,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Tabs value={value} onChange={switchTab}>
            
            <Tab
              id={1}
              label={
                <Badge badgeContent={4} color="success">
                  New
                </Badge>
              }
            />
            <Tab
              id={0}
              label={
                <Badge badgeContent={4} color="primary">
                  Read
                </Badge>
              }
            />
          </Tabs>
        </div>
        <Divider />
      </DialogTitle>
      <Box sx={{ maxHeight: "90%", overflowY: "auto" }}>
        {notifications.map((item, index) => (
          <div key={index}>
            <Box
              sx={{
                px: 3,
                pt: 1,
                pb: 1,
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <img src={CampusLogo} alt="loading" />
              <div>
                <Typography fontWeight={"bold"} color={colors.darkGreyFont}>
                  {item.title}
                </Typography>
                <Typography color={colors.darkGreyFont} variant="caption">
                  {item.description}
                </Typography>
              </div>
            </Box>
            <Divider />
          </div>
        ))}
      </Box>
    </BootstrapDialog>
  );
};
